import { Component, OnDestroy, OnInit } from '@angular/core';
import { UrlHistoryService } from '../../../services/url.history.service';
import { AppState } from '../../../models/AppState';
import { Subscription } from 'rxjs';
import { AppStateService } from '../../../services/app-state.service';
import { AuthorizedApiService } from '../../../services/authorized-api.service';
import { filter, first, flatMap, switchMap, tap } from 'rxjs/operators';
import { FireService } from '../../../services/fire.service';
import { OrderService } from '../../../services/order.service';
import { ConnectCodeResponse } from '../../../models/Order';
import { CircleButtonComponent } from '../../buttons/circle-button.component';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerComponent } from '../../ui/loading-spinner-component';
import { FSConnectAccount } from '../../../models/FSConfig';

@Component({
  selector: 'app-connect-messenger',
    standalone: true,
    imports: [
      CircleButtonComponent,
      CommonModule,
      LoadingSpinnerComponent
    ],
  templateUrl: './connect-messenger.component.html',
  styleUrls: ['./connect-messenger.component.css']
})
export class ConnectMessengerComponent implements OnInit, OnDestroy {
  app: AppState | null = null;
  code: string | null = null;
  connectCode: ConnectCodeResponse | null = null;
  isConnected = false;
  public isLoading = true;
  private sub: Subscription | undefined;
  private subCA: Subscription | undefined;

  constructor(private appState: AppStateService, private identityService: UrlHistoryService,
              private api: AuthorizedApiService, private fire: FireService, private orderService: OrderService) { }

  ngOnInit(): void {
    this.sub = this.appState.observeAppState().pipe(
      first(),
      tap(appState => this.app = appState),
      flatMap(appState => this.api.getConnectCode())
    ).subscribe(code => {
      console.log("GOT STUFF");
      this.isLoading = false;
      this.connectCode = code;
      this.code = code.code;
      this.startObservingConnectAccountStatus();
    });
  }

  ngOnDestroy() {
    if (this.sub) { this.sub.unsubscribe(); }
    if (this.subCA) { this.subCA.unsubscribe(); }
  }

  back() {
    this.identityService.navigateBack("/account");
  }

  private startObservingConnectAccountStatus() {
    if (!this.connectCode || !this.connectCode.document_id) {
      console.error("Connect code or document ID is missing");
      return;
    }
  
    this.subCA = this.fire.observeConnectAccount(this.connectCode.document_id).pipe(
      filter((ca): ca is FSConnectAccount => !!ca && ca.state === "connected"),
      switchMap(() => this.orderService.fetchCurrentOrder())
    ).subscribe({
      next: () => {
        this.isConnected = true;
      },
      error: (err) => {
        console.error("Error observing connect account status:", err);
      }
    });
  }
}
